"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEmptyFeatures = void 0;
var RENDER_FEATURES = ['line', 'beach_surface', 'beach_distance', 'airport_distance', 'wi_fi'];
var isEmptyFeatures = exports.isEmptyFeatures = function isEmptyFeatures(features) {
  if (!features) {
    return true;
  }
  return !RENDER_FEATURES.some(function (feature) {
    return Boolean(features[feature]);
  });
};